import * as React from 'react';
import { SVGProps } from 'react';

export const LightningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="17" viewBox="0 0 11 17" fill="none" {...props}>
    <g id="lightning_1 (1) 1" clip-path="url(#clip0_9048_411)">
      <g id="1">
        <g id="Group">
          <path
            id="Vector"
            d="M10.48 5.78801C10.448 5.72201 10.382 5.68001 10.308 5.68001H7.30199L9.64799 0.976012C9.67799 0.916012 9.67399 0.846012 9.63999 0.790012C9.60599 0.734012 9.54199 0.700012 9.47599 0.700012H3.57599C3.49799 0.700012 3.42599 0.748012 3.39799 0.822012L0.511991 8.27201C0.489991 8.33001 0.495991 8.39601 0.531991 8.44801C0.567991 8.50001 0.625991 8.53001 0.689991 8.53001H3.89199L1.87999 16.23C1.85799 16.318 1.89799 16.408 1.97999 16.448C2.00799 16.462 2.03599 16.468 2.06599 16.468C2.12199 16.468 2.17799 16.442 2.21599 16.396L10.458 5.99001C10.504 5.93201 10.512 5.85401 10.48 5.78801Z"
            fill="#FEB80B"
          />
          <g id="Group_2">
            <path
              id="Vector_2"
              d="M5.36999 0.700012H3.57599C3.49799 0.700012 3.42599 0.748012 3.39799 0.822012L0.511991 8.27201C0.489991 8.33001 0.495991 8.39601 0.531991 8.44801C0.567991 8.50001 0.625991 8.53001 0.689991 8.53001H2.33599L5.36999 0.700012Z"
              fill="#FEA707"
            />
            <path
              id="Vector_3"
              d="M3.89199 8.53203L1.88 16.232C1.858 16.32 1.898 16.41 1.98 16.45C1.98 16.45 1.98 16.45 1.982 16.45L5.768 8.53003H3.89199V8.53203Z"
              fill="#FEA707"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9048_411">
        <rect width="10" height="15.772" fill="white" transform="translate(0.5 0.700012)" />
      </clipPath>
    </defs>
  </svg>
);
